export const SDK_VERSION = '7.120.2';
